import React from 'react';
import styles from './button.module.css';

const Button = ({ text, onClick, extraStyle, styleStyle, extraTextStyle, disabled, loading }) => (
	<button
		className={`${styles.container} ${extraStyle} ${disabled || loading ? styles.disabled : ''}`}
		onClick={() => !disabled && !loading && onClick()}
		style={styleStyle}
		disabled={disabled || loading}
	>
		{loading ? (
			<div className={styles.loader} />
		) : (
			<div className={`${styles.text} ${extraTextStyle || ''}`}>{text}</div>
		)}
	</button>
);

export default Button;
